import { ProdutoRepository } from "../repository/produto_repository";

export class ProdutoService {
	constructor() {
		this.produtoRepository = new ProdutoRepository();
	}

	async getAll(unidadeDistribuidoraId, tipo) {
		return await this.produtoRepository.getAll(unidadeDistribuidoraId, tipo);
	}

	async getByUnidade(unidadeDistribuidoraId, tipo) {
		return await this.produtoRepository.getAll(unidadeDistribuidoraId, tipo);
	}

	async getEmbalagens(produtoId) {
		return await this.produtoRepository.getEmbalagens(produtoId);
	}
}

export default ProdutoService;
